import Axios from "axios";
import { useEffect, useState } from "react";
import { Box, useTheme, IconButton } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";

const Stockledger = () => {

  const [mappedData, setMappedData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch both stockLedger and products simultaneously
        const [stockLedgerRes, productsRes] = await Promise.all([
          Axios.get("https://store.petplanet.rw/api/stock-ledgers"),
          Axios.get("https://store.petplanet.rw/api/products"),
        ]);

        const stockLedgerData = stockLedgerRes.data || [];
        const productsData = productsRes.data || [];

        // Map product name into stockLedger
        const mapped = stockLedgerData.map((stock) => {
          const product = productsData.find(
            (p) => Number(p.id) === Number(stock.product_id)
          );
          return {
            id: stock.id, // Important for DataGrid
            ...stock,
            product_name: product ? product.name : "Unknown",
          };
        });

        setMappedData(mapped);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  
  const columns = [
    { field: "product_name", 
      headerName: "Product Name",
      flex: 1,
    },
    {
      field: "type",
      headerName: "Type",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "quantity",
      headerName: "Quantity",
      flex: 1,
    },
    {
      field: "total",
      headerName: "Total",
      flex: 1,
    },
    {
      field: "balance",
      headerName: "Balance",
      flex: 1,
    },
    {
      field: "date",
      headerName: "Date",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
  ];
  return (
    <>
    <Box m="20px" mt="80px">
      <Header title="Stock Ledger" subtitle="Track stock movements, stockLedger, and sales all in one place." />
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
               "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: tokens.grey[800],
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: tokens.grey[100],
          },
          "& .MuiCheckbox-root": {
            border: "none",
            color: `${tokens.redAccent[400]} !important`,
          },
          "& .MuiDataGrid-columnHeader.action-column--header": {
            background: "none",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: `${tokens.grey[900]} !important`,
            fontSize: "12px",
          },
          "& .MuiDataGrid-columnSeparator--resizable": {
            color: `${tokens.blueAccent[100]} !important`,
          }
            }}
        >
        <DataGrid checkboxSelection rows={mappedData} 
            columns={columns}  
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true, // Ensures the filter search bar is shown
              },
            }}
            sx={{
              "& .MuiDataGrid-toolbarContainer": {
                display: "flex",
                justifyContent: "space-between",
              },
              // Styling for all buttons within the DataGrid
              "& .MuiButton-root": {
                padding: "8px 15px", // Adjust padding for all button
                textTransform: "none", // Keep text in normal case
              },
              "& .MuiButton-text": {
                color: tokens.blueAccent[400], // Text color for text buttons
                "&:hover": {
                  color: tokens.blueAccent[400], // Hover color for text buttons
                },
              },
            }}
         />
      </Box>
    </Box>
  </>
  
  );
};

export default Stockledger;
